import React from "react";
// Framer Motion
import {motion} from 'framer-motion'
// Styled Components
import { Frame1, Frame2, Frame3, Frame4, Hide } from "../styles";
import { pageAnimation, fade, slider, sliderContainer } from "../animation";
import { useScroll } from "../components/useScroll";
import styled from 'styled-components';

const Tour = () => {
    return (
        <TourContainer
            variants={pageAnimation} 
            initial="hidden" 
            exit="exit" 
            animate="show"
        >
            <motion.div variants={sliderContainer}>
                <Frame1 variants={slider}></Frame1>
                <Frame2 variants={slider}></Frame2>
                <Frame3 variants={slider}></Frame3>
                <Frame4 variants={slider}></Frame4>
            </motion.div>

            <Ticket 
                animate={{ opacity: 1, transition: {delay: 1} }}
                initial={{ opacity: 0 }}
            >
                <motion.h2>Los Angeles - 3/29</motion.h2>
                <motion.a href="https://www.eventbrite.com/e/wait-whats-sri-lanka-60-minutes-of-stand-up-with-shenuque-tickets-1982406055878" target="_blank"><motion.button>Get Tickets</motion.button></motion.a>
            </Ticket>

            <Ticket 
                animate={{ opacity: 1, transition: {delay: 1} }}
                initial={{ opacity: 0 }}
            >
                <motion.h2>Vancouver - 4/9</motion.h2>
                <motion.a href="https://www.jumpcomedy.com/e/whats-sri-lanka?variant_id=variant_019ae6b6-0e75-74d0-9c1c-b61ffd0e3568" target="_blank"><motion.button>Get Tickets</motion.button></motion.a>
            </Ticket>

            <Ticket 
                animate={{ opacity: 1, transition: {delay: 1} }}
                initial={{ opacity: 0 }}
            >
                <motion.h2>Montreal - 8/8</motion.h2>
                <motion.a href="https://comedycartel.ca/montreal-comedy-shows" target="_blank"><motion.button>Get Tickets</motion.button></motion.a>
            </Ticket>

            <Ticket 
                animate={{ opacity: 1, transition: {delay: 1} }}
                initial={{ opacity: 0 }}
            >
                <motion.h2>Chicago - 9/10</motion.h2>
                <motion.a href="https://www.comedyplex.com/event/shenuque-tissera-wait-whats-sri-lanka-820/register" target="_blank"><motion.button>Get Tickets</motion.button></motion.a>
            </Ticket>
            
        </TourContainer>
    );
};

const TourContainer = styled(motion.div)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 1rem;
`;

const Ticket = styled(motion.div)`
    display: flex;
    text-align: center;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 3rem 1rem;
    h2{
        margin: 2rem 0rem;
    }
`;

export default Tour;